import { render } from "./AppSidebar.vue?vue&type=template&id=cbd9085c&scoped=true"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"

import "./AppSidebar.vue?vue&type=style&index=0&id=cbd9085c&lang=scss&scoped=true"
import "./AppSidebar.vue?vue&type=style&index=1&id=cbd9085c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbd9085c"]])

export default __exports__